import { useScrollTo } from "../../hooks/useScrollTo";
import { ReadExcel } from "../timetable/ReadExcel";
import { NavLink } from "./NavLink";
import { NavBrand } from "./NavBrand";

export const Navigation = () => {
  const {
    scrollToAbout,
    scrollToServices,
    scrollToDonate,
    scrollToTestimonials,
    scrollToTeam,
    scrollToContact,
    scrollToTop,
  } = useScrollTo();

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <NavBrand onClick={scrollToTop} />
        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ReadExcel />
          <ul className="nav navbar-nav navbar-right">
            <NavLink onClick={scrollToAbout}>About</NavLink>
            <NavLink onClick={scrollToServices}>Programmes</NavLink>
            <NavLink onClick={scrollToTestimonials}>Daily Hadeeth</NavLink>
            <NavLink onClick={scrollToTeam}>Education</NavLink>
            <NavLink onClick={scrollToContact}>Contact</NavLink>
            <li className="nav-donate-btn">
              <a href onClick={scrollToDonate} className="btn btn-donate">
                Donate
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
